import { render, staticRenderFns } from "./AddTemplateModal.vue?vue&type=template&id=35bc55e8&scoped=true"
import script from "./AddTemplateModal.vue?vue&type=script&lang=js"
export * from "./AddTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./AddTemplateModal.vue?vue&type=style&index=0&id=35bc55e8&prod&scoped=true&lang=css"
import style1 from "./AddTemplateModal.vue?vue&type=style&index=1&id=35bc55e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bc55e8",
  null
  
)

export default component.exports